export default __webpack_public_path__ + "static/media/qrcode.15287e93.png";